import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-correlations',
  templateUrl: './correlations.component.html',
  styleUrls: ['./correlations.component.css']
})
export class CorrelationsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
